<template>
  <div class="visitor">
    <!--面包屑-->
    <div class="Fixed">
      <div class="Fixed-right">
        <Breadcrumb>
          <BreadcrumbItem>
            <a @click="goToHome" class="ivu-breadcrumb-item-link">
              <li  class="breader">首页</li>
            </a>
          </BreadcrumbItem>
          <BreadcrumbItem v-for="item in routerMap"
                          :key="item.index" :to="item.path">
            <li class="breader">{{item.name}}</li>
          </BreadcrumbItem>
        </Breadcrumb>
      </div>
    </div>
    <div class="content">
      <div class="nav">
        <i-form inline :model="searchForm" :rules="ruleForm" ref="searchForm" :label-width="110">
          <FormItem label="姓名：" :label-width="50" style="font-size: .18rem">
            <i-input type="text" v-model.trim="searchForm.name" style="width: 1.2rem" placeholder="请输入完整姓名"/>
          </FormItem>
          <FormItem label="性别："  style="font-size: .18rem">
            <i-select v-model="searchForm.sex" style="width:1rem">
              <Option value="全部">全部</Option>
              <Option value="男">男</Option>
              <Option value="女">女</Option>
            </i-select>
          </FormItem>
          <FormItem label="身份证："  style="font-size: .18rem" prop="code">
            <i-input type="text" v-model="searchForm.code" :maxlength=18  placeholder="请输入完整身份证号码"/>
          </FormItem>
          <FormItem label="来访对象："  style="font-size: .18rem;margin-right: .05rem">
            <i-select v-model="searchForm.target" style="width:1rem;margin-right: .28rem" >
              <Option value="全部">全部</Option>
              <Option value="校长">校长</Option>
              <Option value="主任">主任</Option>
              <Option value="班任">班任</Option>
              <Option value="科任">科任</Option>
              <Option value="其他">其他</Option>
            </i-select>
          </FormItem>
          <FormItem label="来访事由：" :label-width="75" style="font-size: .18rem">
            <i-select v-model="searchForm.reason" style="width: 1rem;" >
              <Option value="全部" >全部</Option>
              <Option value="设备维护" >设备维护</Option>
              <Option value="业务洽谈">业务洽谈</Option>
              <Option value="开家长会">开家长会</Option>
              <Option value="其他">其他</Option>
            </i-select>
          </FormItem>
          <FormItem label="来访日期：" :label-width="100" style="font-size: .18rem" prop="data">
            <date-picker format="yyyy/MM/dd" type="daterange" placement="bottom-end"
                         v-model="searchForm.data" :options="dataTime"
                         placeholder="选择日期" style="width: 2.2rem"></date-picker>
          </FormItem>
          <FormItem :label-width="30" >
            <Button type="success" @click="handleSubmit('searchForm')" >查询</Button>
          </FormItem>
          <FormItem :label-width="30">
            <Button type="success" @click="exportData">导出excel</Button>
          </FormItem>
        </i-form>
      </div>
      <div class="navTable">
        <div class="tableTop"><span>来访人数：{{visitorList.total}}人次</span></div>
        <div class="tableContent"><Table border :columns="visitor" :data="visitorList.list" style="margin-top: .2rem" ref="visitorTable"></Table>
          <Table border :columns="visitor1" :data="hidTable" style="margin-top: .2rem;display: none" ref="visitorTable2" ></Table>
          <Page :total="visitorList.total" :current="this.page"  @on-change="changePage" style="margin-top: 0.1rem;float: right"/></div>
      </div>
    </div>
    <Modal
      v-model="nowPicType"
      arrow="never" dots="none"
      footer-hide
      >
      <img style="margin: 18px 0 10px 0" :src="this.nowPic"  >
    </Modal>
    <Modal
      v-model="nowPicType2"
      arrow="never" dots="none"
      footer-hide
      width="150px"
    >
      <img style="margin: 16px 8px 8px 5px" :src="this.nowPic"  >
    </Modal>
  </div>
</template>

<script>
import {getVisitor} from '../../api/api'
import excel from '../../common/js/tableToExcel'
import {goToHome} from '@/common/js/cookie'
export default {
  name: 'visitor',
  mounted () {
    this.getVisitorList()
  },
  computed: {
    // 面包屑路由获取
    routerMap () {
      let routerMap = this.$route.matched
      let routerMap1 = routerMap.concat()
      if (routerMap1.length > routerMap1.length - 1) {
        routerMap1[1].path = ''
        return routerMap1
      } else {
        return routerMap1
      }
    }
  },
  data () {
    const validateData = (rule, value, callback) => {
      if (value[0]) {
        let nowTime = Date.now()
        let endTime = value[1].getTime()
        if (endTime > nowTime + 8600000) {
          callback(new Error('时间超过今天'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请选择时间'))
      }
    }
    const validateCode = (rule, value, callback) => {
      if (value.length === 18) {
        let codeType = this.idCard(value)
        if (codeType === true) {
          callback()
        } else {
          callback(new Error('身份证不合法'))
        }
      } else if (value.length === 15) {
        let codeType = this.idCard(value)
        if (codeType === true) {
          callback()
        } else {
          callback(new Error('身份证不合法'))
        }
      } else if (value.length > 0 && value.length <= 15) {
        callback(new Error('身份证长度错误'))
      } else if (value.length > 15 && value.length < 18) {
        callback(new Error('身份证长度错误'))
      } else {
        callback()
      }
    }
    return {
      nowPicType: false,
      nowPicType2: false,
      hidTable: [],
      nowPic: '',
      formIndex: 0,
      sexList: '',
      page: 1,
      visitorList: {
        total: 0
      },
      thingList: '',
      searchForm: {
        name: '',
        sex: '全部',
        code: '',
        target: '全部',
        reason: '全部',
        data: '',
        sTime: '',
        eTime: '',
        page: 1
      },
      dataTime: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 15724800000
        }
      },
      // 表格的判断
      ruleForm: {
        data: [
          { required: true, type: 'date', validator: validateData, trigger: 'change' }
        ],
        code: [
          {validator: validateCode, trigger: 'blur'}
        ]
      },
      // 表格的数据
      visitor: [
        {
          title: '姓名',
          key: 'name',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'person'
                }
              }),
              h('strong', params.row.name)
            ])
          }
        },
        {
          title: '性别',
          key: 'sex',
          align: 'center'
        },
        {
          title: '现场照片',
          key: 'photo',
          align: 'center',
          columns: {
            'width': '60px'
          },
          render: (h, params) => {
            return h('div', [
              h('img', {
                attrs: {
                  src: params.row.photo
                },
                style: {
                  width: '45px',
                  height: '50px'
                },
                on: {
                  click: () => {
                    this.enlarge(params.row.photo)
                  }
                }
              })
            ])
          }
        },
        {
          title: '身份证照',
          key: 'zp',
          align: 'center',
          columns: {
            'width': '60px'
          },
          render: (h, params) => {
            return h('div', [
              h('img', {
                attrs: {
                  src: params.row.zp
                },
                style: {
                  width: '45px',
                  height: '50px',
                  margin: '5px 0'
                },
                on: {
                  click: () => {
                    this.enlarge2(params.row.zp)
                  }
                }
              })
            ])
          }
        },
        {
          title: '身份证号码',
          key: 'code',
          align: 'center',
          minWidth: 60
        },
        {
          title: '来访对象',
          key: 'target',
          align: 'center'
        },
        {
          title: '来访事由',
          key: 'reason',
          align: 'center'
        },
        {
          title: '来访时间',
          align: 'center',
          key: 'check_in'
        },
        {
          title: '离开时间',
          align: 'center',
          key: 'check_out'
        }
      ],
      visitor1: [
        {
          title: '姓名',
          key: 'name',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'person'
                }
              }),
              h('strong', params.row.name)
            ])
          }
        },
        {
          title: '性别',
          key: 'sex',
          align: 'center'
        },
        {
          title: '现场照片',
          key: 'photo',
          align: 'center',
          columns: {
            'width': '60px'
          },
          render: (h, params) => {
            return h('div', [
              h('img', {
                attrs: {
                  src: params.row.photo
                },
                style: {
                  width: '50px',
                  height: '50px'
                },
                on: {
                  click: () => {
                    this.enlarge(params.row.photo)
                  }
                }
              })
            ])
          }
        },
        {
          title: '身份证照',
          key: 'zp',
          align: 'center',
          columns: {
            'width': '60px'
          },
          render: (h, params) => {
            return h('div', [
              h('img', {
                attrs: {
                  src: params.row.zp
                },
                style: {
                  width: '50px',
                  height: '50px'
                },
                on: {
                  click: () => {
                    this.enlarge(params.row.zp)
                  }
                }
              })
            ])
          }
        },
        {
          title: '身份证号码',
          key: 'code',
          align: 'center'
        },
        {
          title: '来访对象',
          key: 'target',
          align: 'center'
        },
        {
          title: '来访事由',
          key: 'reason',
          align: 'center'
        },
        {
          title: '来访时间',
          align: 'center',
          key: 'check_in',
          minWidth: 200
        },
        {
          title: '离开时间',
          align: 'center',
          key: 'check_out',
          minWidth: 120
        }
      ]
    }
  },
  methods: {
    goToHome () {
      goToHome()
    },
    // 获取表格数据
    async getVisitorList (pageNum) {
      if (this.searchForm.data[0]) {
        let exportDate1 = new Date(this.searchForm.data[0])
        let exportDate2 = new Date(this.searchForm.data[1])
        let a = exportDate1.getFullYear()
        let b = (exportDate1.getMonth() + 1)
        let c = exportDate1.getDate()
        if (b < 10) {
          b = '0' + b
        }
        if (c < 10) {
          c = '0' + c
        }
        let i = exportDate2.getFullYear()
        let j = (exportDate2.getMonth() + 1)
        let k = exportDate2.getDate()
        if (j < 10) {
          j = '0' + j
        }
        if (k < 10) {
          k = '0' + k
        }
        this.searchForm.sTime = a + '-' + b + '-' + c
        this.searchForm.eTime = i + '-' + j + '-' + k
        let data = {
          name: this.searchForm.name,
          sex: this.searchForm.sex,
          code: this.searchForm.code,
          target: this.searchForm.target,
          reason: this.searchForm.reason,
          stime: this.searchForm.sTime,
          etime: this.searchForm.eTime,
          hasPage: 1,
          page: pageNum
        }
        const res = await getVisitor(data)
        if (res.code === 0) {
          if (res.data) {
            this.visitorList = res.data
          } else {
            this.visitorList = []
            this.visitorList.total = 0
            this.$Message.info('无相关数据')
          }
        }
      }
      return this.visitorList
    },
    // 获取全部数据
    getallData (pageIndex) {
      let exportDate1 = new Date(this.searchForm.data[0])
      let exportDate2 = new Date(this.searchForm.data[1])
      let a = exportDate1.getFullYear()
      let b = (exportDate1.getMonth() + 1)
      let c = exportDate1.getDate()
      if (b < 10) {
        b = '0' + b
      }
      if (c < 10) {
        c = '0' + c
      }
      let i = exportDate2.getFullYear()
      let j = (exportDate2.getMonth() + 1)
      let k = exportDate2.getDate()
      if (j < 10) {
        j = '0' + j
      }
      if (k < 10) {
        k = '0' + k
      }
      this.searchForm.sTime = a + '-' + b + '-' + c
      this.searchForm.eTime = i + '-' + j + '-' + k
      let data = {
        name: this.searchForm.name,
        sex: this.searchForm.sex,
        code: this.searchForm.code,
        target: this.searchForm.target,
        reason: this.searchForm.reason,
        stime: this.searchForm.sTime,
        etime: this.searchForm.eTime,
        hasPage: 1,
        page: pageIndex
      }
      return getVisitor(data)
    },
    // 身份证正则判断
    idCard (code) {
      let judge18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      let judge15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/
      if (code.length === 18 && judge18.test(code) === true) {
        return true
      } else if (code.length === 15 && judge15.test(code) === true) {
        return true
      } else {
        return false
      }
    },
    // 放大图片
    enlarge (src) {
      this.nowPicType = true
      this.nowPic = src
    },
    enlarge2 (src) {
      this.nowPicType2 = true
      this.nowPic = src
    },
    // 判断
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.getVisitorList(1)
          let exData = []
          let exTotal = 0
          new Promise((resolve, reject) => {
            this.getallData(1).then(result => {
              if (result.data) {
                exTotal = result.data.total
                return result.data.total
              } else {
              }
            }).then(total => {
              let len = Math.ceil(total / 10)
              for (let i = 0; i < len; i++) {
                this.getallData(i + 1).then(result => {
                  return result.data.list
                }).then(tempDate => {
                  exData.push.apply(exData, tempDate)
                  if (exData.length === exTotal) {
                    resolve(exData)
                  }
                })
              }
            })
          }).then(data => {
            this.hidTable = data
          })
        } else {
          this.$Message.info('请选择日期')
        }
      })
    },
    // excel导出
    exportData () {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          let exData = []
          let exTotal = 0
          new Promise((resolve, reject) => {
            this.getallData(1).then(result => {
              if (result.data) {
                exTotal = result.data.total
                return result.data.total
              } else {
                this.$Message.info('无数据')
              }
            }).then(total => {
              let len = Math.ceil(total / 10)
              for (let i = 0; i < len; i++) {
                this.getallData(i + 1).then(result => {
                  return result.data.list
                }).then(tempDate => {
                  exData.push.apply(exData, tempDate)
                  if (exData.length === exTotal) {
                    resolve(exData)
                  }
                })
              }
            })
          }).then(data => {
            this.hidTable = data
            this.excel1()
          })
        }
      })
    },
    excel1 () {
      let exportDate1 = this.searchForm.data[0]
      let exportDate2 = this.searchForm.data[1]
      let b = (exportDate1.getMonth() + 1)
      let c = exportDate1.getDate()
      if (b < 10) {
        b = '0' + b
      }
      if (c < 10) {
        c = '0' + c
      }
      let j = (exportDate2.getMonth() + 1)
      let k = exportDate2.getDate()
      if (j < 10) {
        j = '0' + j
      }
      if (k < 10) {
        k = '0' + k
      }
      let exportTime1 = exportDate1.getFullYear() + '' + b + '' + c
      let exportTime2 = exportDate2.getFullYear() + '' + j + '' + k
      let filename = '校园访客记录' + exportTime1 + '-' + exportTime2 + '.xls'
      excel(this.visitor1, this.$refs.visitorTable2, filename)
    },
    changePage (index) { // 页码选择
      this.getVisitorList(index)
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .Fixed
    height .53rem;
    background-color #e9ecee;
    border-bottom 1px #cfd1d3 solid;
    box-shadow 1px 1px 5px 1px #d9dcde;
    .Fixed-right
      float: right;
      text-align: center;
      line-height: .53rem;
      margin-right .3rem;
      .breader
        font-size .16rem
        display inline
  .content
    margin-left .3rem
    margin-top .2rem
    .nav
      span
        font-size .2rem
        line-height .3rem
        text-align center
        display:inline-block
    .navTable
      margin .1rem .3rem .2rem 0
      .tableTop
        span
          font-size .18rem
      .tableContent
        Table
          img
            width 100px
</style>



// WEBPACK FOOTER //
// src/views/visitor/visitor.vue